import { Model } from "@interfaces/model.interface";

export interface CrmEventAttendee extends Model {
	crmEventId: number;
	userProfileId: number;
}

export class CrmEventAttendee implements CrmEventAttendee {

	constructor(data?: Partial<CrmEventAttendee>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
